import {Fragment, useEffect, useState, useContext} from 'react';

// import LoginContext from '../../../../../store/login-context';
import BackStep from '../General/BackStep/BackStep';
import ProgressBar from '../ProgressBar/ProgressBar';
import SignupHelp from '../SignupHelp/SignupHelp';
import UpdateAnswers from '../UpdateAnswers/UpdateAnswers';
import classes from './PibaNoCard.module.scss';

declare function Translate(key: string): string;
declare var _curLang: any;

const PibaNoCard = (props) => {
    // const ctx = useContext(LoginContext);

    const onBackStepHandler = () => {
        props.prevScreen(); 
    };

    const onUpdateAnswersClick = () => {
        props.firstScreen();
    };

    const handleGovVisitClick = () => {
        switch (_curLang) {
            case "he":
                window.location.href = "https://govisit.gov.il/he/app/appointment/262/412010/v2/questionnaire";
                break;
            case "en":
                window.location.href = "https://govisit.gov.il/en/app/appointment/262/412010/v2/questionnaire";
                break;
            case "ru":
                window.location.href = "https://govisit.gov.il/ru/app/appointment/262/412010/v2/questionnaire";
                break;
            case "ar":
                window.location.href = "https://govisit.gov.il/ar/app/appointment/262/412010/v2/questionnaire";
                break;
        
            default:
                break;
        }
    };

    const handleGovVisitPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleGovVisitClick();
        }
    };

    return(        
        <Fragment> 
            <ProgressBar pbWidth="100%"/>                                             
            <div className={classes.container}>   
                <div>         
                    <BackStep prevStep = {onBackStepHandler} />
                
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_Bio_ID_No_Card_Title')}</div>            
                    <div className={`preRegText ${classes.desc}`}>                    
                        <span>{Translate('N_Login_Bio_ID_No_Card_Instructions')}</span>                        
                        <a id='govVisit' 
                            className={classes.gov_visit_link} 
                            onClick={handleGovVisitClick}
                            onKeyPress={handleGovVisitPress}
                            tabIndex={0}               
                            > 
                            {Translate('N_General_GovVisit_Site')}                    
                        </a>                      
                    </div>
                    <div className={`preRegText ${classes.desc}`}>
                        <span className={classes.bold}>{Translate('N_Login_SignUp_Bio_ID_Instructions')}</span>
                        <span>                                    
                            <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                <div className="gov-tooltiptitle">{Translate('N_Login_What_Is_SC_Reader')}</div>
                                <div className={`gov-tooltiptext ${classes.tooltip_pos}`} tabIndex={0}>
                                    {Translate('N_Login_What_Is_SC_Reader_Tooltip')}
                                </div>
                            </a> 
                        </span> 
                    </div>                            
                    <div className={classes.buttons_container}>
                        <button className={classes.btn_gov_visit} id='btnGovVisit' onClick={handleGovVisitClick}>
                            <span>{Translate('N_Login_Bio_ID_Get_Turn')}</span>                     
                        </button>                                          
                    </div> 

                    <UpdateAnswers  onLinkClick={onUpdateAnswersClick}/>     
                </div>
                <div className={classes.signup_help}>
                    <SignupHelp />
                </div>
            </div>  
        </Fragment>
    );
    
};
export default PibaNoCard;